const globalVar = {}
// globalVar.baseUrl = "https://innerapi.dumovie.com/route?"
globalVar.baseUrl = "https://innerapi.mayiufu.com/route?"

// globalVar.signKey = "A18F1B200C24842671FD1C9926B6EE35"
// globalVar.appkey = "dumovie_wxmicro"
globalVar.signKey = "D8972106E4349D541C90B0C28C7CD4E7"
// globalVar.appkey = "dumovie_wap"
// globalVar.appkey = JSON.parse(localStorage.getItem('appkey'))

globalVar.imgBaseUrl = "https://res.dumovie.com/"

globalVar.txid = ""

globalVar.isIPhoneX  = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812
globalVar.isIPhoneXSMax = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896
globalVar.isIPhoneXR = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896

export default globalVar




// WEBPACK FOOTER //
// ./src/common/js/global_variable.js